import * as Sentry from '@sentry/react'
import { StrictMode } from 'react'
import * as ReactDOM from 'react-dom/client'

import App from './App'
import { FallbackComponent } from './components/SentryFallbackError'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

const sentryDNS = import.meta.env.VITE_SENTRY_DNS
const sentryENV = import.meta.env.VITE_APP_ENV
const isLocalhost = window.location.hostname === 'localhost'

if (sentryDNS && !isLocalhost) {
  Sentry.init({
    dsn: sentryDNS,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    environment: sentryENV
  })
}

root.render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={FallbackComponent}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>
)
